import { type UseInfiniteQueryOptions, useInfiniteQuery } from '@lumapps/base-api/react-query';

import { GetMultiFeedParams, getMultiFeed, feedQueryKeys } from '../api';

export type UseGroupsInfiniteQueryOptions = UseInfiniteQueryOptions;

/**
 * Hook in order to retrieve Groups by their IDs, filter and load more of them.
 * @returns UseGroups
 */
export const useQueryGroupByIds = (params: GetMultiFeedParams, options?: UseGroupsInfiniteQueryOptions) => {
    const multiFeedQuery = useInfiniteQuery({
        ...options,
        queryKey: feedQueryKeys.getMultiFeed(params),
        queryFn: async ({ pageParam, signal }) => {
            const { data } = await getMultiFeed({ ...params, cursor: pageParam }, signal);

            return data;
        },
        getNextPageParam: (lastPage) => (lastPage?.more ? lastPage?.cursor : undefined),
    });

    return multiFeedQuery;
};
